import { createModel } from "@rematch/core";

import * as api from "../api";
import { RootModel } from ".";
import { checkToken, signoutIfUnauthorized } from "./utilities";

const initialState = {
  salutationsData: [],
};

export const salutationsData = createModel<RootModel>()({
  state: initialState as { salutationsData: Array<{ salutation: string }> },
  reducers: {
    fetchSuccess(state, payload: Array<{ salutation: string }>) {
      return {
        ...state,
        salutationsData: payload,
      };
    },
    fetchFail(state) {
      return { ...state };
    },
  },
  effects: (dispatch) => ({
    async fetchSalutationsData(payload: null, rootState) {
      const token = checkToken(rootState, () =>
        dispatch.salutationsData.fetchFail()
      );
      if (!token) return;

      try {
        const salutationsDataResult = await api.fetchSalutations(token);
        dispatch.salutationsData.fetchSuccess(salutationsDataResult.data);
      } catch (error) {
        signoutIfUnauthorized(error, dispatch);
        dispatch.salutationsData.fetchFail();
        // eslint-disable-next-line no-console
        console.error(error);
      }
    },
  }),
});



// WEBPACK FOOTER //
// ./src/models/salutationsData.ts